<script setup lang="ts">
import { Ref } from 'vue'

const { onSubmit } = inject<any>('form')

useTimeoutFn(() => {
  onSubmit()
}, 2000)

const lowBid = inject('lowBid') as Ref<boolean>

useDemandCheck({
  condition: () => {
    if (query.utm_source?.toLowerCase() === 'google') {
      enterExperiment('grocery2024GoogleDemandCheck')
      if (exp.value?.grocery2024GoogleDemandCheck?.shouldCheck) {
        return true
      }
    }
    return false
  },
  onResult: (isLowBid) => {
    lowBid.value = isLowBid
  },
})
</script>

<template>
  <FormProgress class="!mb-6" />

  <div class="text-3xl sm:text-4xl text-center">
    Searching for a licensed insurance agent in your area...
  </div>

  <div class="flex justify-center">
    <Spinner />
  </div>
</template>
